module.exports = __webpack_public_path__ + "static/media/matic.4c01c874.webp";